import { Box, Container } from '@mui/material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export function MainContent({ children }: { children: React.ReactNode }) {
    return (
        <MainContainer>
            <MainContentBox>{children}</MainContentBox>
        </MainContainer>
    );
}

export function MainContainer({
    children,
    sx,
}: {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}) {
    return (
        <Box
            sx={{
                height: '100vh',
                backgroundColor: 'whitesmoke.main',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                overflowY: 'auto',
            }}
        >
            <Container
                disableGutters={true}
                sx={[
                    {
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        minHeight: 0,
                        paddingTop: '72px',
                        paddingBottom: '24px',
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            >
                {children}
            </Container>
        </Box>
    );
}

export function MainContentBox({ children }: { children: React.ReactNode }) {
    return (
        <Box
            sx={{
                backgroundColor: 'common.white',
                borderRadius: 1,
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
            }}
        >
            {children}
        </Box>
    );
}
